import { useEffect } from "react"
import { useLocation } from "react-router-dom"

/**
 * ScrollToTop — cuộn lên đầu trang mỗi khi đổi route (hành vi chuẩn của web đa trang).
 * [BLACK BOX] — gắn sẵn trong App.tsx.
 */
export function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior })
  }, [pathname])
  return null
}
